export default {
      id: "sort-usage",
      viewBox: "0 0 12 10",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#sort",
      toString: function () {
        return this.url;
      }
    }